import { Breadcrumbs, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import { DownloadsCharts } from "../../components";
import { downloadSummaryEnabled, hasPermission } from "../../components/Permissions";
import Permissions from "../../constants/permissions";
import { useAccountContext } from "../../strict/app/AccountResolver";
import useAuth from "../../context/UserContext";

const DownloadsChartsPage = () => {
  const { user } = useAuth();
  const isDownloadSummaryEnabled = downloadSummaryEnabled(user);
  const { urlName } = useAccountContext();

  if (isDownloadSummaryEnabled || hasPermission(Permissions.ManageGlobalUsers, user)) {
    return (
      <>
        <Breadcrumbs>
          <NavLink to={`/app/${urlName}/dashboard`} key={"Homepage"}>
            <Typography variant="body.overline.regular">Home</Typography>
          </NavLink>
          <Typography variant="body.overline.bold">Download chart</Typography>
        </Breadcrumbs>
        <DownloadsCharts />
      </>
    );
  }
  return null;
};

export { DownloadsChartsPage };
